import { useState } from "react";
import { Link } from "react-router-dom";
import { FAQS } from "@/mocks/content";
import { Eyebrow } from "@/components/ui/primitives";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <Eyebrow text="常见问题" en="FAQ" />
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
                关于幕外，你可能想问
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                还没想明白的，可以直接写信到 {""}
                <a href="mailto:hello@muwai.example.com" className="text-primary-300 hover:text-primary-200">
                  hello@muwai.example.com
                </a>
                ，我们会认真回每一封。
              </p>
              <Link
                to="/about"
                className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-primary-300 transition hover:text-primary-200"
              >
                深入了解幕外 <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="flex flex-col gap-3">
              {FAQS.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div key={f.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : i)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <h3 className="font-heading text-base font-semibold text-foreground-950">{f.q}</h3>
                      <span
                        className={
                          "flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-500 transition " +
                          (isOpen ? "rotate-45 border-primary-400 text-primary-300" : "")
                        }
                      >
                        <i className="ri-add-line" />
                      </span>
                    </button>
                    {isOpen && (
                      <div className="border-t border-background-200 px-5 py-4">
                        <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}